import React from 'react';
import { IconButton, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { Sun, Moon } from 'lucide-react';
export function DarkModeToggle() {
  const {
    colorMode,
    toggleColorMode
  } = useColorMode();
  const icon = colorMode === 'dark' ? <Sun size={18} data-id="element-138" /> : <Moon size={18} data-id="element-139" />;
  return <IconButton aria-label="Toggle dark mode" variant="ghost" icon={icon} onClick={toggleColorMode} color="neonBlue.400" _hover={{
    bg: 'rgba(0, 153, 255, 0.1)'
  }} data-id="element-140" />;
}